import * as yup from 'yup';
import { passwordPattern } from '../variables';

export const changePasswordValidationSchema = yup.object().shape({
  currentPassword: yup.string().required('passwordRequired'),
  newPassword: yup
    .string()
    .matches(new RegExp(passwordPattern), 'passwordNotValid')
    .required('passwordRequired'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'confirmPasswordMismatch')
    .required('passwordRequired'),
});
